import { render, staticRenderFns } from "./MessagesCopyToClipboard.vue?vue&type=template&id=9769cb3c&scoped=true"
import script from "./MessagesCopyToClipboard.vue?vue&type=script&lang=js"
export * from "./MessagesCopyToClipboard.vue?vue&type=script&lang=js"
import style0 from "./MessagesCopyToClipboard.vue?vue&type=style&index=0&id=9769cb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9769cb3c",
  null
  
)

export default component.exports